<template>
  <main class="">
    <article class="CardConfirmarPedido w-100">
      <form @submit.prevent="salvarEndereco" class="row my-0 px-0 px-lg-4 py-0">
        <div :class="enderecoIgual ? 'col-12 col-lg-6' : 'col-12'">
          <h4 class="py-4">Endereço de entrega</h4>
          <div class="form-group">
            <label>CEP</label>
            <input
              v-if="cep && cep.length === 10"
              type="text"
              class="form-control"
              v-model="cep"
              readonly
            />
            <input
              v-if="cep.length < 9"
              type="text"
              @keyup.enter="getByCep()"
              @blur="getByCep()"
              class="form-control"
              v-model="cep"
              maxlength="8"
              required
              disabled
            />
            <small class="text-muted" v-if="loadingCepEndereco">
              <span class="spinner-border spinner-border-sm"></span>
              Buscando seu CEP
              <span class="button-loader grey ml-2"></span>
            </small>
          </div>
          <div class="form-group">
            <label>Logradouro</label>
            <input
              type="text"
              class="form-control"
              v-model="enderecoEntrega.endereco"
              required
            />
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">Complemento</label>
            <input
              type="text"
              class="form-control"
              v-model="enderecoEntrega.complemento"
            />
          </div>
          <div class="row" style="margin: 0 -15px;">
            <div class="form-group col">
              <label for="exampleInputPassword1">Número</label>
              <input
                type="text"
                class="form-control"
                v-model="enderecoEntrega.numero"
                required
              />
            </div>
            <div class="form-group col">
              <label for="exampleInputPassword1">Bairro</label>
              <input
                type="text"
                class="form-control"
                v-model="enderecoEntrega.bairro"
                required
              />
            </div>
          </div>
          <div class="row" style="margin: 0 -15px;">
            <div class="form-group col-6">
              <label for="exampleInputPassword1">Cidade</label>
              <input
                type="text"
                class="form-control"
                v-model="enderecoEntrega.cidade"
                required
              />
            </div>
            <div class="form-group col-6">
              <label for="exampleInputPassword1">UF</label>
              <input
                type="text"
                class="form-control"
                v-model="enderecoEntrega.estado"
                required
              />
            </div>
          </div>
          <div>
            <div class="col-12 d-flex">
              <input type="checkbox" id="checkbox" v-model="enderecoIgual" />
              <label class="ml-3" for="checkbox"
                >Endereço de cobrança
                <span class="font-weight-bold">diferente</span> do endereço de
                entrega?</label
              >
            </div>
          </div>
        </div>
        <div
          :class="enderecoIgual ? 'col-12 col-lg-6' : 'col-12'"
          v-if="enderecoIgual"
        >
          <h4 class="py-4">Endereço de cobrança</h4>
          <div class="form-group">
            <label>CEP</label>
            <input
              type="text"
              @keyup.enter="getByCep('cepCobranca')"
              @blur="getByCep('cepCobranca')"
              class="form-control"
              v-model="cepCobranca"
              required
            />
            <small class="text-muted" v-if="loadingCep">
              <span class="spinner-border spinner-border-sm"></span>
              Buscando seu CEP
              <span class="button-loader grey ml-2"></span>
            </small>
            <small class="text-muted" v-if="cepNaoLocalizado"
              >CEP não localizado</small
            >
          </div>
          <div class="form-group">
            <label>Logradouro</label>
            <input
              type="text"
              class="form-control"
              v-model="enderecoCobranca.endereco"
              required
            />
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">Complemento</label>
            <input
              type="text"
              class="form-control"
              v-model="enderecoCobranca.complemento"
            />
          </div>
          <div class="row" style="margin: 0 -15px;">
            <div class="form-group col">
              <label for="exampleInputPassword1">Número</label>
              <input
                type="text"
                class="form-control"
                v-model="enderecoCobranca.numero"
                required
              />
            </div>
            <div class="form-group col">
              <label for="exampleInputPassword1">Bairro</label>
              <input
                type="text"
                class="form-control"
                v-model="enderecoCobranca.bairro"
                required
              />
            </div>
          </div>
          <div class="row" style="margin: 0 -15px;">
            <div class="form-group col-6">
              <label for="exampleInputPassword1">Cidade</label>
              <input
                type="text"
                class="form-control"
                v-model="enderecoCobranca.cidade"
                required
              />
            </div>
            <div class="form-group col-6">
              <label for="exampleInputPassword1">UF</label>
              <input
                type="text"
                class="form-control"
                v-model="enderecoCobranca.estado"
                required
              />
            </div>
          </div>
        </div>
        <div
          class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between"
        >
          <button
            class="btn btn-secondary px-5 mt-4 py-2"
            @click="goToStep('pedido')"
          >
            VOLTAR
          </button>
          <button class="btn btn_color_system py-2 px-5 mt-4" type="submit">
            SALVAR ENDEREÇO
          </button>
        </div>
      </form>
    </article>
  </main>
</template>

<script>
import { enderecoNoWrap } from "../../shared/helpers/helpers";
import { APIService } from "../../APIService";
const apiService = new APIService();

export default {
  name: "StepEndereco",
  components: {},
  props: [
    "cep",
    "idPedido",
    "objEndereco",
    "objEnderecoCobranca",
    "objEnderecoIgual"
  ],
  data() {
    return {
      user: this.$store.state.user,
      enderecoUser: null,
      enderecoForm: false,
      loadingCep: false,
      cepNaoLocalizado: false,
      enderecoIgual: false,
      loadingCepEndereco: false,
      enderecoEntrega: {
        cep: "",
        endereco: "",
        complemento: "",
        numero: "",
        bairro: "",
        cidade: "",
        estado: "",
        pais: ""
      },
      cepCobranca: "",
      enderecoCobranca: {
        cep: "",
        endereco: "",
        complemento: "",
        numero: "",
        bairro: "",
        cidade: "",
        estado: "",
        pais: ""
      }
    };
  },
  created() {
    this.enderecoUser =
      this.user && this.user.pessoa.endereco
        ? this.endereco(this.user.pessoa.endereco)
        : null;
    if (this.objEndereco) {
      this.enderecoEntrega = this.objEndereco;
      this.enderecoCobranca = this.objEnderecoCobranca;
      this.cepCobranca = this.objEnderecoCobranca.cep;
      this.enderecoIgual = this.objEnderecoIgual;
    } else {
      this.getByCep();
    }
  },
  methods: {
    getByCep(cepCobranca) {
      this.cepNaoLocalizado = false;
      if (!cepCobranca) this.loadingCepEndereco = true;
      if (!this.loadingCep) {
        this.loadingCep = true;
        apiService
          .getCep(cepCobranca ? this.cepCobranca : this.cep)
          .then(res => {
            if (res != "") {
              cepCobranca
                ? (this.enderecoCobranca = res)
                : (this.enderecoEntrega = res);
              this.loadingCep = false;
            } else {
              this.loadingCep = false;
              this.cepNaoLocalizado = true;
            }
          })
          .catch(() => {
            this.loadingCep = false;
            this.cepNaoLocalizado = true;
          })
          .finally(() => {
            if (!cepCobranca) this.loadingCepEndereco = false;
          });
      }
    },
    salvarEndereco() {
      this.enderecoEntrega.tipo = 'ENTREGA';
      this.enderecoCobranca.tipo = 'COBRANCA';

      apiService
        .salvarEntrega(this.enderecoEntrega, this.idPedido)
        .then(() => {
          if(!this.enderecoIgual) {
            this.$emit("handleEndereco", {
              enderecoEntrega: this.enderecoEntrega,
              enderecoCobranca: this.enderecoCobranca,
              enderecoIgual: this.enderecoIgual
            });
            this.goToStep("pagamento");
          } else  {
            apiService
              .salvarEntrega(this.enderecoCobranca, this.idPedido)
              .then(() => {
                this.$emit("handleEndereco", {
                  enderecoEntrega: this.enderecoEntrega,
                  enderecoCobranca: this.enderecoCobranca,
                  enderecoIgual: this.enderecoIgual
                });
                this.goToStep("pagamento");
              });
          }
        });
    },
    endereco(end) {
      return enderecoNoWrap(end);
    },
    goToStep(step) {
      this.$emit("goToStep", step);
    }
  }
};
</script>
<style scoped lang="scss"></style>
